import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import { installPwaAssetRecovery, initSentry, SaveFailedNotice } from "@cliqsuite/ui";
import { SAVE_REFUSED_EVENT } from "@cliqsuite/db/powersync";
import { PowerSyncContext } from "@powersync/react";
import { Capacitor } from "@capacitor/core";
import { KeepAwake } from "@capacitor-community/keep-awake";
import { router } from "./router";
import { connectKds, db } from "./lib/db";
import "./styles.css";

installPwaAssetRecovery();
initSentry("kitchen-display", import.meta.env.VITE_SENTRY_DSN, import.meta.env.MODE);
// In the installed app the kitchen screen never sleeps mid-service.
if (Capacitor.isNativePlatform()) void KeepAwake.keepAwake().catch((err) => Sentry.captureException(err));
// Rendered after the wipe, so the board never shows the last session's tickets.
void connectKds()
  .catch((err) => Sentry.captureException(err))
  .finally(() =>
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
          <PowerSyncContext.Provider value={db}>
            <RouterProvider router={router} />
            <SaveFailedNotice event={SAVE_REFUSED_EVENT} />
          </PowerSyncContext.Provider>
        </Sentry.ErrorBoundary>
      </StrictMode>,
    ),
  );
